import { Link } from '@material-ui/core';
import { faqLink, DAILY_REPORT_FOLDER_NAME } from '../../const/Const';
import { econtractStatusState } from '../fileListPage/FileList';
import { constructTypeData } from '../../GlobalState';

// ツールチップ内に表示される内容
export const tooltipContents = {
  // 日報URL発行
  DailyReportUrl: (
    <>
      <div>協力会社、職人など、</div>
      <div>社外の人が日報を作成できる</div>
      <div>URLを発行します。</div>
    </>
  ),
  // 日報（職人）URL有効期限
  DailyReportExpirationDate: (
    <>
      <div>URLにアクセスできる</div>
      <div>有効期限を設定します。</div>
    </>
  ),
  // 日報社外パートナー作成
  DailyReportOutsidePartner: (
    <>
      <div>※社外パートナー日報に原価要因の</div>
      <div>入力はありません。</div>
    </>
  ),
  // ストレージ自動連携ボタン
  PhotoSyncEnabledButton: (
    <>
      <div>ONにすると</div>
      <div>写真一覧の「{DAILY_REPORT_FOLDER_NAME}」</div>
      <div>フォルダに自動で写真を連携します。</div>
    </>
  ),
  // ストレージ自動連携ボタン（URL発行）
  PhotoSyncEnabledButtonForWokers: (
    <>
      <div>ONにすると、依頼者の写真フォルダに</div>
      <div>自動で写真を連携します。</div>
    </>
  ),
  // カレンダーURL発行
  CalenderUrl: (
    <>
      <div>Googleカレンダーに</div>
      <div>インポートできるURLを作成します。</div>
      <Link
        href={faqLink.calendar_url}
        target='_blank'
        rel='noopener noreferrer'
        color='inherit'
        style={{ fontSize: 12, textDecoration: 'underline' }}
      >
        ヘルプページ
      </Link>
    </>
  ),
  // カレンダー画面、タスクアラート
  CalenderAlert: (
    <>
      <div> 期限を過ぎたタスクです。</div>
      <div>（未着手または着手中が対象）</div>
    </>
  ),
  // ガントチャート内「追加」ボタン
  AddSiteProcess: (
    <>
      <div>工程を追加します。</div>
    </>
  ),
  // タスク一覧モーダル、チェックボックス
  TaskView: (
    <>
      <div>大工程を選択した場合に、</div>
      <div>紐づく小工程のタスクも表示します。</div>
    </>
  ),
  // タスク作成・編集モーダル、発注書欄
  TaskForOrder: (
    <>
      <div>作成済みの発注書と</div>
      <div>紐付けることができます。</div>
      <div>設定すると、期限が近づいた際に</div>
      <div>メールでお知らせします。</div>
      <div>（未着手または着手中が対象）</div>
    </>
  ),
  // 各チェックボックス
  selectDelete: (
    <>
      <div>選択したものを一括削除します。</div>
    </>
  ),
  // 見積編集の全選択チェックボックス
  selectAll: (
    <>
      <div>すべての行を選択します。</div>
    </>
  ),
  // プレビューボタン
  preview: (
    <>
      <div>書類を印刷用に表示し、</div>
      <div>PDFファイルをダウンロードできます。</div>
    </>
  ),
  // 選択削除(工事一覧)
  constructionsSelectDelete: (
    <>
      <div>選択した工事を</div>
      <div>一括削除します。</div>
    </>
  ),
  // 選択削除(書類一覧)
  documenSelectDeletet: (
    <>
      <div>選択した書類を</div>
      <div>一括削除します。</div>
    </>
  ),
  // 選択削除(見積書マスタ)
  estimateMasterSelectDelete: (
    <>
      <div>選択した見積書マスタを</div>
      <div>一括削除します。</div>
    </>
  ),
  // 選択削除(単位マスタ)
  unitMasterSelectDelete: (
    <>
      <div>選択した単位マスタを</div>
      <div>一括削除します。</div>
    </>
  ),
  // 選択削除(顧客)
  customersSelectDelete: (
    <>
      <div>選択した顧客を</div>
      <div>一括削除します。</div>
    </>
  ),
  // 選択削除(顧客種別)
  customertypesSelectDelete: (
    <>
      <div>選択した顧客種別を</div>
      <div>一括削除します。</div>
    </>
  ),
  // 選択削除(業者)
  vendorsSelectDelete: (
    <>
      <div>選択した業者を</div>
      <div>一括削除します。</div>
    </>
  ),
  // 選択削除(受取書類)
  receivedSelectDelete: (
    <>
      <div>選択した受取書類を</div>
      <div>一括削除します。</div>
    </>
  ),
  // 工事(新規作成)
  constructionsCreateNew: (
    <>
      <div>登録した顧客情報から、</div>
      <div>工事案件を作成します。</div>
    </>
  ),
  // 工事(エクスポート)
  constructionsExport: (
    <>
      <div>工事の一覧をCSVファイルで</div>
      <div>ダウンロードします。</div>
    </>
  ),
  // 工事（作成・詳細）(担当者情報、追加)
  constructionsCreateManager: (
    <>
      <div>担当者を追加します。</div>
    </>
  ),
  // 工事（作成・詳細）(社外パートナー情報、追加)
  constructionsCreateOutsidePartner: (
    <>
      <div>社外パートナーを追加します。</div>
    </>
  ),
  // 工事（作成・詳細）(小口経費明細、追加)
  constructionsCreateExpenses: (
    <>
      <div>小口経費の項目を</div>
      <div>追加します。</div>
    </>
  ),
  // 工事（作成・詳細）(テナント情報（自社情報へ変更）)
  constructionsCreateTenant: (
    <>
      <div>各書類の自社情報に</div>
      <div>反映されます。</div>
    </>
  ),
  // 契約者
  contractor: (
    <>
      <div>「契約先」や「締結先」など、</div>
      <div>契約者が顧客と異なる場合に</div>
      <div>入力してください。</div>
    </>
  ),
  // 書類(新規作成)
  documenCreateNew: (
    <>
      <div>工事を選択して</div>
      <div>書類を作成します。</div>
    </>
  ),
  // 書類(エクスポート)
  documenExport: (
    <>
      <div>書類（帳票）の一覧を</div>
      <div>CSVファイルでダウンロードします。</div>
    </>
  ),
  // 請求書作成・編集
  invoice: (
    <>
      <div>見積を追加します。</div>
    </>
  ),
  // 書類管理、商品発注書作成・編集
  productPurchaseOrder: (
    <>
      <div>品名を追加します。</div>
    </>
  ),
  // 書類管理、外注発注書作成・編集
  outsourcedPurchaseOrder: (
    <>
      <div>工事内容を追加します。</div>
    </>
  ),
  // 単位マスタ
  itemUnit: (
    <>
      <div>単位マスタから</div>
      <div>選択できる単位を</div>
      <div>編集することができます。</div>
    </>
  ),
  // メモ
  author_memo: (
    <>
      <div>備考は見積書PDFに出力されます。</div>
      <div>先方へ提示する内容の記載をお願いいたします。</div>
      <div>社内用メモは見積書PDFに出力されません。</div>
      <div>社内管理用としてご利用ください。</div>
    </>
  ),
  // 見積書マスタ
  quotationMaster: (
    <>
      <div>見積書作成時に</div>
      <div>必要な項目名や単価を、</div>
      <div>テンプレートとして</div>
      <div>事前に登録します。</div>
    </>
  ),
  // 見積書マスタ(作成・編集)
  quotationMasterAddition: (
    <>
      <div>小項目を追加します。</div>
    </>
  ),
  // 単位マスタ
  unitMaster: (
    <>
      <div>書類作成時に</div>
      <div>必要な単位を、</div>
      <div>テンプレートとして</div>
      <div>事前に登録します。</div>
    </>
  ),
  // 案件種別マスタ
  constructType: (
    <>
      <div>工事設定に使用する、案件</div>
      <div>種別を任意の項目で登録で</div>
      <div>きます</div>
    </>
  ),
  // 顧客一覧（エクスポート）
  customerList: (
    <>
      <div>顧客情報をCSVファイルで</div>
      <div>ダウンロードします。</div>
    </>
  ),
  // 見積書マスタ(メール送信)
  customerListSendMail: (
    <>
      <div>宛先グループを選択すると</div>
      <div>お問い合わせ内容を、</div>
      <div>指定した社員グループに</div>
      <div>メールで送信できます。</div>
    </>
  ),
  // 業者一覧(エクスポート)
  vendorsListExport: (
    <>
      <div>業者の一覧をCSVファイルで</div>
      <div>ダウンロードします。</div>
    </>
  ),
  // 業者一覧(業種（大項目）、検索(選択に変更）)
  vendorsListCreateEdit: (
    <>
      <div>業種の大項目と</div>
      <div>小項目を選択します。</div>
    </>
  ),
  // 社員マスタ(選択削除)
  employeeMasterSelectDelete: (
    <>
      <div>チェックした社員を</div>
      <div>ログイン不可にします。</div>
    </>
  ),
  // 社員マスタ(エクスポート)
  employeeMasterExport: (
    <>
      <div>社員の一覧をCSVファイルで</div>
      <div>ダウンロードします。</div>
    </>
  ),
  // 社員マスタ(活性化→有効化)
  employeeMasterActivation: (
    <>
      <div>社員をログイン可能にします。</div>
    </>
  ),
  // 社員権限設定
  permissionSettings: (
    <>
      <div>権限によって利用できる機能が異なります。</div>
      <Link
        href={faqLink.permission_settings}
        target='_blank'
        rel='noopener noreferrer'
        color='inherit'
        style={{ fontSize: 12, textDecoration: 'underline' }}
      >
        ヘルプページ
      </Link>
    </>
  ),
  // 社員退職
  employeeRetirement: (
    <>
      <div>退職を選択するとCONOCに</div>
      <div>ログインができなくなります。</div>
    </>
  ),
  // 2段階認証
  mfa: (
    <>
      <div>ログイン時に本人確認を２回に分けて行い、</div>
      <div>不正アクセスを防止する機能です。</div>
      <Link
        href={faqLink.mfa}
        target='_blank'
        rel='noopener noreferrer'
        color='inherit'
        style={{ fontSize: 12, textDecoration: 'underline' }}
      >
        ヘルプページ
      </Link>
    </>
  ),
  // 自社情報自由記入欄
  companyFreeField: (
    <>
      <div>請求書の自由入力欄に</div>
      <div>反映されます。</div>
    </>
  ),
  // 今回請求金額 (税込)
  billingTotalPrice: (
    <>
      <div>消費税の端数が合わない際に</div>
      <div>今回請求金額の手入力が可能です。</div>
      <div>ただし、調整金につきましては記載</div>
      <div>されませんので、事前に請求先との</div>
      <div>取り決めをお願いいたします。</div>
    </>
  ),
  // 外部ファイル共有(資料)
  ShareFileLink: (
    <>
      <div style={{ padding: 4 }}>
        <div style={{ fontSize: 14 }}>共有リンクを作成し</div>
        <div style={{ fontSize: 14 }}>フォルダ内の資料を社外に共有できます</div>
        <Link
          href={faqLink.url_share}
          target='_blank'
          rel='noopener noreferrer'
          color='inherit'
          style={{ fontSize: 12, textDecoration: 'underline' }}
        >
          ヘルプページ
        </Link>
      </div>
    </>
  ),
  // 外部ファイル共有(写真)
  SharePictureLink: (
    <>
      <div style={{ padding: 4 }}>
        <div style={{ fontSize: 14 }}>共有リンクを作成し</div>
        <div style={{ fontSize: 14 }}>フォルダ内の写真を社外に共有できます</div>
        <Link
          href={faqLink.url_share}
          target='_blank'
          rel='noopener noreferrer'
          color='inherit'
          style={{ fontSize: 12, textDecoration: 'underline' }}
        >
          ヘルプページ
        </Link>
      </div>
      1
    </>
  ),
  // 外部ファイル共有、メールアドレス
  ShareEmail: (
    <>
      <div style={{ padding: 2 }}>
        <p style={{ fontSize: 14, margin: 0 }}>
          メールアドレスを登録すると、共有ページのリンクをメールで送信することができます。
        </p>
        <Link
          href={faqLink.create_url}
          target='_blank'
          rel='noopener noreferrer'
          color='inherit'
          style={{ fontSize: 12, textDecoration: 'underline' }}
        >
          ヘルプページ
        </Link>
      </div>
    </>
  ),
  // 外部ファイル共有、有効期限
  ShareExpirationDate: (
    <>
      <div>共有先がアクセスできる期限を設定します。</div>
      <div>設定しない場合は無期限で共有されます。</div>
    </>
  ),
  // 外部ファイル共有、有効期限
  ShareUploadable: (
    <>
      <div>
        <div>チェックを入れると、</div>
        <div>共有先にアップロード権限を付与します。</div>
        <Link
          href={faqLink.uploadable}
          target='_blank'
          rel='noopener noreferrer'
          color='inherit'
          style={{ fontSize: 12, textDecoration: 'underline' }}
        >
          ヘルプページ
        </Link>
      </div>
    </>
  ),
  // 支払期日の自動計算
  paymentDateAuto: (
    <>
      <div>顧客取引情報の入金サイトと</div>
      <div>請求書発行日から自動的に計算されます</div>
    </>
  ),
  // 請求書の営業担当者PDF出力ON/OFF
  salesOutput: (
    <>
      <div>チェックをするとPDFに営業担当を出力できます。</div>
      <div>
        最終操作履歴がユーザーごとに保存され、ほか書類にも自動適用されます。
      </div>
    </>
  ),
  invoiceFreeField: (
    <>
      <div>自社情報の自由入力欄に</div>
      <div>定型文を登録できます。</div>
    </>
  ),
  // 請求書PDFに明細表示の出力ON/OFF
  addDetails: (
    <>
      <div>見積書の明細が反映されます。</div>
    </>
  ),
  factoring: (
    <>
      <div>（株）ラボル様への</div>
      <div>利用申し込みページに</div>
      <div>に遷移します</div>
    </>
  ),
  // 追加原価
  additionalCost: (
    <>
      <div>
        実行予算表で追加した原価の合計値を表示しています。
        <br />
        <br />
        <a
          href='https://phrygian-maxilla-3b4.notion.site/3172b417a14246a8bdb9bae1a9193772'
          target='_blank'
          style={{ color: 'white' }}
        >
          ヘルプページ
        </a>
      </div>
    </>
  ),
  // 登録番号
  companyNum: (
    <>
      <div>ビジネスや取引の際に</div>
      <div>使用される識別番号です。</div>
      <div>インボイス等の税務目的で発行されます。</div>
    </>
  ),
  // 実行予算の項目表示
  displayDetails: (
    <>
      <div>「仕様・詳細」「見積単価」「見積金額」の</div>
      <div>表示/非表示を切替できます</div>
    </>
  ),
  // 実行予算:未発注総額
  Buffer: (
    <>
      <div>実行予算タブ、追加原価タブでの未発注の総額です。</div>
      <div>（見積原価合計額 + 追加原価）- 発注総額</div>
    </>
  ),
  // 実行予算:追加原価
  AdditionalCost: (
    <>
      <div>見積項目以外で追加発生するコストの合計額です。</div>
      <div>（追加原価タブの原価の合計額）</div>
    </>
  ),
  // 実行予算:最終粗利金額
  FinalGrossProfit: (
    <>
      <div>追加原価を差し引いた最終的な粗利金額です。</div>
      <div>粗利金額 - 追加原価</div>
    </>
  ),
  // 実行予算:最終粗利率
  FinalGrossProfitMargin: (
    <>
      <div>追加原価を差し引いた最終的な粗利率です。</div>
      <div>最終粗利金額 ÷ 見積合計額</div>
    </>
  ),
  // 実行予算:発注総額
  OrderTotal: (
    <>
      <div>実行予算タブ、追加原価タブで業者に設定した発注金額の合計です。</div>
    </>
  ),
  // 実行予算:追加項目
  AdditionalCostTab: (
    <>
      <div>見積書に記載のない原価等を追加できます</div>
    </>
  ),
  // 見積書:見積書番号新規作成
  CreateNewEstimateCode: (
    <>
      <div>任意の見積書番号を設定できます。</div>
      <div>入力しない場合は自動採番になります。</div>
    </>
  ),
  // 見積書:見積書番号編集
  EditEstimateCode: (
    <>
      <div>任意の見積書番号を設定できます。</div>
    </>
  ),

  // 顧客別請求書の説明
  CreateCustomerSpecificInvoice: (
    <>
      <div>顧客の複数工事をまとめた請求書を作成することができます。</div>
    </>
  ),
  // 電子契約:契約大臣のグループ
  KeiyakuDaijinGroup: (
    <>
      <div>契約大臣に登録されているグループです。</div>
    </>
  ),
  // 送付先名
  EcontractDestinationName: (
    <>
      <div>送付先は1件のみ指定可能です。</div>
      <div>署名タイプは「電子サイン」</div>
      <div>認証タイプは「Eメール認証」となります。</div>
    </>
  ),
  // 工事 追加情報（箱機能）
  constructionsExtInfoBox: (
    <>
      <div>チェックを入れた追加情報は、</div>
      <div>工事一覧画面に表示されるようになり、</div>
      <div>絞り込み検索およびCSVエクスポートが</div>
      <div>
        可能となります。
        <Link
          href={faqLink.construct_ext_info_box}
          target='_blank'
          rel='noopener noreferrer'
          color='inherit'
          style={{ fontSize: 12, textDecoration: 'underline' }}
        >
          ヘルプページ
        </Link>
      </div>
    </>
  ),
  // 顧客 追加情報（箱機能）
  clientExtInfoBox: (
    <>
      <div>チェックを入れた追加情報は、</div>
      <div>顧客一覧画面に表示されるようになり、</div>
      <div>絞り込み検索およびCSVエクスポートが</div>
      <div>可能となります。 </div>
    </>
  )
};
